import React from "react";
import { Link } from "react-router-dom";
import {
  Paper,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Typography,
  Tooltip,
} from "@mui/material";

import { MdOutlineLocalPhone, MdOutlineMail } from "react-icons/md";
import { TbWorldWww } from "react-icons/tb";

const ContactInfo = ({ userInfo }) => {
  const mainColor = "#286a94";
  const maxLength = 35;

  const truncate = (text = "") =>
    text.length > maxLength ? text.slice(0, maxLength) + "..." : text;

  const formatPhone =
    userInfo?.mobile &&
    `${userInfo?.dialCode ? `+${userInfo?.dialCode} ` : ""}${userInfo.mobile}`;

  const contactItems = [
    {
      label: "Email",
      value: userInfo?.email || "N/A",
      icon: <MdOutlineMail size={20} />,
      isLink: false,
    },
    {
      label: "Phone",
      value: formatPhone || "N/A",
      icon: <MdOutlineLocalPhone size={20} />,
      isLink: false,
    },
    {
      label: "Website",
      value: userInfo?.companyWebsite || "N/A",
      icon: <TbWorldWww size={20} />,
      isLink: true,
      link: userInfo?.companyWebsite,
    },
  ];

  const isExternal = (url) => /^https?:\/\//.test(url);

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: "20px",
        background: "rgba(255,255,255,0.96)",
        border: "1px solid rgba(148,163,184,0.18)",
        boxShadow:
          "0 14px 30px rgba(15,23,42,0.08), 0 0 0 1px rgba(255,255,255,0.7) inset",
      }}
    >
      {/* Heading */}
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 700,
          mb: 2.5,
          color: mainColor,
          letterSpacing: 0.5,
        }}
      >
        Contact Information
      </Typography>

      {/* Contact Items */}
      <List disablePadding>
        {contactItems.map(({ label, value, icon, isLink, link }, idx) => (
          <ListItem
            key={idx}
            sx={{
              mb: idx !== contactItems.length - 1 ? 2 : 0,
              p: 0,
            }}
          >
            <ListItemAvatar>
              <Avatar
                sx={{
                  bgcolor: "rgba(40,106,148,0.10)",
                  color: mainColor,
                  width: 40,
                  height: 40,
                }}
              >
                {icon}
              </Avatar>
            </ListItemAvatar>

            <Tooltip title={`${value}`} placement="top" arrow>
              {isLink && value !== "N/A" ? (
                isExternal(value) ? (
                  <a
                    href={value}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      color: mainColor,
                      textDecoration: "none",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "250px",
                      display: "inline-block",
                    }}
                  >
                    {truncate(value)}
                  </a>
                ) : (
                  <Link
                    to={value}
                    style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      color: mainColor,
                      textDecoration: "none",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "220px",
                      display: "inline-block",
                    }}
                  >
                    {truncate(value)}
                  </Link>
                )
              ) : (
                <Typography
                  sx={{
                    fontSize: 15,
                    color: "#444",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "220px",
                  }}
                >
                  {truncate(value)}
                </Typography>
              )}
            </Tooltip>
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default ContactInfo;
